module.exports = __webpack_public_path__ + "assets/img/videopc.71111fda.png";